var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-lg-3"},[_c('p',{staticClass:"font-poppins-regular text-white"},[_vm._v(_vm._s(_vm.model.name))]),_c('p',{staticClass:"font-poppins-semibold text-white"},[_vm._v(_vm._s(_vm.model.lastname))])])}
var staticRenderFns = []

export { render, staticRenderFns }